document.addEventListener('DOMContentLoaded', () => {
  const desktopMedia = window.matchMedia('(min-width: 1200px)')

  document.querySelectorAll('#navbar-desktop .dropdown-toggle[data-menu-link]').forEach((toggle) => {
    toggle.addEventListener('click', (event) => {
      if (!desktopMedia.matches) return
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
      if (event.button !== 0) return

      const url = toggle.dataset.menuLink
      if (!url) return

      event.preventDefault()
      event.stopPropagation()
      window.location.href = url
    })
  })
})

;(() => {
  const productCardSelector = '.coding-product-card, .product-card'
  const reducedMotionQuery = window.matchMedia?.('(prefers-reduced-motion: reduce)')
  const observedProductCards = new WeakSet()

  if (!('IntersectionObserver' in window)) return

  const productCardObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return

      entry.target.classList.remove('invisible')
      entry.target.classList.add('fade-in-up')
      productCardObserver.unobserve(entry.target)
    })
  }, { threshold: 0.15 })

  const initProductCardReveals = (root = document) => {
    if (reducedMotionQuery?.matches) return

    const productCards = root instanceof Element && root.matches(productCardSelector)
      ? [root, ...root.querySelectorAll(productCardSelector)]
      : root.querySelectorAll(productCardSelector)

    productCards.forEach((productCard) => {
      if (observedProductCards.has(productCard)) return

      observedProductCards.add(productCard)
      productCard.classList.add('invisible')
      productCardObserver.observe(productCard)
    })
  }

  initProductCardReveals()

  document.addEventListener('shopify:section:load', (event) => {
    initProductCardReveals(event.target)
  })

  window.addEventListener('kt.collection.loaded', () => {
    initProductCardReveals(document.querySelector('.collection-products') || document)
  })
})()

;(() => {
  const storageKey = 'spa-ceylon-entrance-promotion-dismissed'

  document.addEventListener('DOMContentLoaded', () => {
    const modal = document.querySelector('[data-entrance-promotion-modal]')
    if (!modal || !window.bootstrap?.Modal) return

    try {
      if (window.sessionStorage.getItem(storageKey) === 'true') return
    } catch (error) {}

    modal.addEventListener('hidden.bs.modal', () => {
      try {
        window.sessionStorage.setItem(storageKey, 'true')
      } catch (error) {}
    }, { once: true })

    window.bootstrap.Modal.getOrCreateInstance(modal).show()
  })
})()

;(() => {
  const marqueeInstances = new WeakMap()
  const reducedMotionQuery = window.matchMedia?.('(prefers-reduced-motion: reduce)')

  const destroyMarquee = (track) => {
    const instance = marqueeInstances.get(track)
    if (!instance) return

    cancelAnimationFrame(instance.rafId)
    window.removeEventListener('resize', instance.onResize)
    document.removeEventListener('visibilitychange', instance.onVisibility)
    track.querySelectorAll('.coding-text-marquee__sequence.is-clone').forEach((node) => node.remove())
    track.style.transform = ''
    marqueeInstances.delete(track)
  }

  const initMarquee = (track) => {
    destroyMarquee(track)

    if (reducedMotionQuery?.matches) return

    const viewport = track.closest('.coding-text-marquee__viewport')
    const baseSequence = track.querySelector('.coding-text-marquee__sequence:not(.is-clone)')
    if (!viewport || !baseSequence) return

    const direction = track.dataset.marqueeDirection === 'right' ? 'right' : 'left'
    const speed = Number(track.dataset.marqueeSpeed) || 70

    let sequenceWidth = 0
    let position = 0
    let rafId = null
    let lastTime = 0
    let resizeTimer = null

    const measure = () => {
      track.querySelectorAll('.coding-text-marquee__sequence.is-clone').forEach((node) => node.remove())

      sequenceWidth = baseSequence.getBoundingClientRect().width
      if (!sequenceWidth) return

      const viewportWidth = viewport.getBoundingClientRect().width
      let totalWidth = sequenceWidth

      while (totalWidth < viewportWidth + sequenceWidth) {
        const clone = baseSequence.cloneNode(true)
        clone.classList.add('is-clone')
        clone.setAttribute('aria-hidden', 'true')
        track.appendChild(clone)
        totalWidth += sequenceWidth
      }

      position = direction === 'right' ? -sequenceWidth : 0
      track.style.transform = `translate3d(${position}px, 0, 0)`
    }

    const step = (time) => {
      if (!sequenceWidth) {
        rafId = null
        return
      }

      if (!lastTime) lastTime = time
      const dt = (time - lastTime) / 1000
      lastTime = time
      const delta = speed * dt

      if (direction === 'left') {
        position -= delta
        if (Math.abs(position) >= sequenceWidth) position = 0
      } else {
        position += delta
        if (position >= 0) position = -sequenceWidth
      }

      track.style.transform = `translate3d(${position}px, 0, 0)`
      rafId = requestAnimationFrame(step)
    }

    const start = () => {
      cancelAnimationFrame(rafId)
      lastTime = 0
      rafId = requestAnimationFrame(step)
    }

    const stop = () => {
      cancelAnimationFrame(rafId)
      rafId = null
    }

    const onResize = () => {
      clearTimeout(resizeTimer)
      resizeTimer = window.setTimeout(() => {
        measure()
        if (sequenceWidth && !document.hidden) start()
        else stop()
      }, 150)
    }

    const onVisibility = () => {
      if (document.hidden) {
        stop()
      } else if (sequenceWidth) {
        start()
      }
    }

    measure()
    if (sequenceWidth && !document.hidden) start()

    window.addEventListener('resize', onResize)
    document.addEventListener('visibilitychange', onVisibility)

    marqueeInstances.set(track, {
      rafId,
      onResize,
      onVisibility
    })
  }

  const initMarquees = (root = document) => {
    root.querySelectorAll('[data-marquee-track]').forEach((track) => initMarquee(track))
  }

  document.addEventListener('DOMContentLoaded', () => {
    initMarquees()
  })

  document.addEventListener('shopify:section:load', (event) => {
    initMarquees(event.target)
  })
})()
